import React, { useState } from "react";
import PropTypes from 'prop-types';

import { connect } from "react-redux";

import { Link } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import logo from "../../assets/images/logo-sm.png";
import logoLight from "../../assets/images/web_logo.png";
import logoDark from "../../assets/images/web_logo.png";

// import images
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

//i18n
import { withTranslation } from "react-i18next";

const Header = props => {
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }
  function tToggle() {
    var body = document.body
    var windowSize = document.documentElement.clientWidth

    body.classList.toggle("vertical-collpsed")
    body.classList.toggle("sidebar-enable")

    if (windowSize > 991) {
      body.getAttribute("data-sidebar-size") === "sm"
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm")
    }
  }

  return ( 
    <React.Fragment>
      <div className="navbar-header d-flex flex-wrap justify-content-between align-items-center px-3 py-2">



        {/* Left Side: Logo and Toggle */}
        <div className="d-flex align-items-center flex-shrink-0">


          {/* Mobile Toggle */}
          <button
            type="button"
            className="btn btn-sm d-lg-none header-item me-2"
            onClick={() => props.toggleLeftmenu(!props.leftMenu)}
          >
            <i className="fa fa-fw fa-bars" />
          </button>
        </div>

        {/* Center: Search */}
        <div className="flex-grow-1 d-none d-lg-block mx-2">
          <form className="app-search">
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
              />
              <span className="uil-search position-absolute top-50 translate-middle-y start-0 ms-3 text-muted" />
            </div>
          </form>
        </div>

        {/* Right Side */}
        <div className="d-flex align-items-center flex-shrink-0">
          {/* Mobile Search */}
          <div className="dropdown d-inline-block d-lg-none me-2">
            <button
              type="button"
              className="btn header-item noti-icon"
              onClick={() => setSearch(!isSearch)}
            >
              <i className="uil-search"></i>
            </button>
            <div
              className={
                isSearch
                  ? "dropdown-menu show p-0"
                  : "dropdown-menu p-0"
              }
            >
              <form className="p-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={props.t("Search") + "..."}
                  />
                  <button className="btn btn-primary" type="submit">
                    <i className="mdi mdi-magnify" />
                  </button>
                </div>
              </form>
            </div>
          </div>

          <LanguageDropdown />

          <Dropdown
            className="d-none d-lg-inline-block mx-2"
            isOpen={socialDrp}
            toggle={() => setsocialDrp(!socialDrp)}
          >
            <DropdownToggle className="btn header-item noti-icon" caret tag="button">
              <i className="uil-apps" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
              {/* Social links... */}
            </DropdownMenu>
          </Dropdown>

          <button
            className="btn header-item noti-icon d-none d-lg-inline-block"
            onClick={toggleFullscreen}
          >
            <i className="uil-minus-path"></i>
          </button>

          <NotificationDropdown />
          <ProfileMenu />

          <button
            className="btn header-item noti-icon right-bar-toggle"
            onClick={() => props.showRightSidebarAction(!props.showRightSidebar)}
          >
            <i className="uil-cog"></i>
          </button>
        </div>
      </div>
    </React.Fragment>

  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
